import * as React from 'react'
import { connect } from 'react-redux';
import { compose } from 'redux';
 
import useAppStartup from './useAppStartup'
 
const App: React.FC<IProps> = ({ children }) => {
  useAppStartup();
 
  return (
    <div className="App">
      {children}
    </div>
  );
 
}
 
export interface IProps {
  pending?: boolean;
  children: React.ReactNode;
}
 
export default compose(
  connect()
)(App);
//  export default App;